module.exports = __webpack_public_path__ + "img/logo.abc3d49b.jpg";